__turbopack_context__.v({
  "announcementButton": "OyU4zW_announcementButton",
  "announcementContainer": "OyU4zW_announcementContainer",
  "announcementText": "OyU4zW_announcementText",
  "blueBackground": "OyU4zW_blueBackground",
  "eyebrowContainer": "OyU4zW_eyebrowContainer",
  "greenBackground": "OyU4zW_greenBackground",
  "indigoBackground": "OyU4zW_indigoBackground",
  "inlineAnnouncement": "OyU4zW_inlineAnnouncement",
  "leftButtonContainer": "OyU4zW_leftButtonContainer",
  "linkContainer": "OyU4zW_linkContainer",
  "orangeBackground": "OyU4zW_orangeBackground",
  "redBackground": "OyU4zW_redBackground",
  "rightButtonContainer": "OyU4zW_rightButtonContainer",
  "titleContainer": "OyU4zW_titleContainer",
  "yellowBackground": "OyU4zW_yellowBackground",
});
